import React, { Component } from 'react'
import ReactTable from 'react-table'
import 'react-table/react-table.css'

class WHTable extends Component {
  constructor(props) {
    super(props)
  }

  filterMethod(filter, row, column) {
    const id = filter.pivotId || filter.id

    if (row[id] === undefined || !row[id]) return true
    if (filter.value === undefined || !filter.value) return true

    const value = String(row[id].toLowerCase())
    const search = String(filter.value.toLowerCase())

    if (value.indexOf(search) > -1) return true

    return false
  }

  render() {
    const {
      defaultFiltered,
      defaultSorted,
      data,
      pages,
      loading,
      columns,
      noDataText,
      filterable,
      defaultPageSize = 20,
      pageSize = 20
    } = this.props

    return (
      <ReactTable
        manual
        defaultFilterMethod={this.filterMethod}
        previousText={'Prec'}
        nextText={'Suiv'}
        data={data}
        pages={pages}
        defaultFiltered={defaultFiltered}
        defaultSorted={defaultSorted}
        loading={loading}
        noDataText={noDataText ? noDataText : 'Pas de résultats'}
        filterable={filterable}
        columns={columns}
        showPageSizeOptions={false}
        onFetchData={this.props.onFetchData}
        className="-striped -highlight"
        defaultPageSize={defaultPageSize}
        pageSize={pageSize}
        rowsText={'lignes'}
      />
    )
  }
}

export default WHTable



// WEBPACK FOOTER //
// ./src/components/WHTable/index.js